import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Alert, Button, Modal, FormControl, FormGroup } from 'react-bootstrap';
import ShipmentsActionCreators from 'actions/ShipmentsActionCreators';
import ShipmentStore from 'stores/ShipmentStore';

class ShareModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      input: '',
      errorMessage: '',
      successMessage: '',
    };
  }

  shareShipment() {
    const payload = { recipient: this.state.input };
    if (this.isPhoneNumber()) {
      payload.notification_type = 'sms';
    }
    if (this.isEmail()) {
      payload.notification_type = 'email';
    }
    ShipmentsActionCreators.shareShipment(this.props.job._id, payload);
    this.props.onCloseModal();
  }

  isValid() {
    return !!(this.isPhoneNumber() || this.isEmail());
  }

  isPhoneNumber() {
    const regex = /\b\d{3}[-.\s]?\d{3}[-.\s]?\d{4}\b/;
    return regex.test(this.state.input);
  }

  isEmail() {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(this.state.input);
  }

  updateInput = (event) => {
    this.setState({
      input: event.target.value,
    });
  }

  handleAlertDismiss = () => {
    this.setState(
      {
        errorMessage: '',
        successMessage: '',
      },
      this.props.onCloseModal(),
    );
    ShipmentStore.removeChangeListener(this.handleChange);
  }

  render() {
    const { t } =  this.props;
    return (
      <div className="share_modal">
        <Modal
          show={this.props.showModal}
        >
          <Modal.Header>
            <Modal.Title><span className="share_modal_header_text">{t('SHARE_THIS_SHIPMENT')}</span>
              <Button
                className="close_share_modal"
                onClick={() => {
                  this.handleAlertDismiss();
                }}
              >X
              </Button>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            bsStyle=""
          >
            <div>
              <h5 className="modal_body_text">{t('SHARE_TRACKING_LINK_FOR_SHIPMENT')}</h5>
            </div>
            <div>
              <h5>{t('EMAIL_OR_PHONE_FOR_SHARE')}:</h5>
            </div>
            <div className="modal_form_container">
              <FormGroup
                validationState={this.isValid() ? null : 'error'}
              >
                <FormControl
                  type="text"
                  value={this.state.email}
                  onChange={this.updateInput}
                  className="modal_share_input"
                />
              </FormGroup>
              <Button
                bsStyle="info"
                bsSize="large"
                disabled={!this.isValid()}
                onClick={() => this.shareShipment()}
                className="modal_share_button"
              >
                {t('SHARE')}
              </Button>
            </div>
            <div>
              <p className="modal_note">{t('NEVER_SHARES_YOUR_COST')}</p>
            </div>
            {this.props.job.short_url && (
              <div>
                <p>{t('SEND_LINK')}:</p>
                <div className="modal_link_box">
                  <h2>{this.props.job.short_url}</h2>
                </div>
              </div>
            )}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

ShareModal.propTypes = {
  showModal: PropTypes.bool,
  job: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    short_url: PropTypes.string.isRequired,
  }).isRequired,
  onCloseModal: PropTypes.func.isRequired,
};

ShareModal.defaultProps = {
  showModal: false,
};

export default withTranslation()(ShareModal)
